package pl.decks.personal.components.widgets.timeline

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import pl.decks.personal.styles.SiteLayout

@Composable
fun YearlySplitRangeTimeline(
    range: YearMonth.Range,
    isShowingYearLabel: Boolean = true,
    yearLabelAlignment: Alignment = Alignment.Center,
    monthRenderer: MonthRenderer = MonthRenderer.default,
    modifier: Modifier = Modifier
) = Row(modifier) {
    range.splitByYear().forEach { yearRange ->
        val isStarting = yearRange.from.month == Month.JANUARY
        RangeTimeline(
            range = yearRange,
            isShowingYearLabel = isShowingYearLabel && isStarting,
            yearLabelAlignment = yearLabelAlignment,
            monthRenderer = monthRenderer,
            modifier = Modifier
                .width((yearRange.span.toDouble() / range.span).times(100).percent)
                .thenIf(isStarting) {
                    Modifier.borderLeft(
                        width = SiteLayout.Line.Normal,
                        style = LineStyle.Solid,
                        color = MonthlyTimelineStylesheet.Vars.yearBreakColor
                            .value(ColorMode.current.toPalette().border.toRgb().copyf(alpha = 0.5f)),
                    )
                },
        )
    }
}
